import React, { useMemo } from 'react';
import * as styles from './field_wrapper.module.sass';
import { FieldWrapperProps } from './props.type';
import classNames from 'classnames';
import { Size } from '../../enums/size';

export const FieldWrapper = (props: FieldWrapperProps) => {
  const { children, hint, className, dataCy, wrapperClassName, size = Size.LARGE } = props;
  const { wrapper, error_message, hint_message, element_label, label_wrapper, error_icon } = styles;

  const errors = useMemo(() => {
    if (!props.errors) {
      return null;
    }

    return <p className={error_message}>{props.errors}</p>;
  }, [props.errors]);

  return (
    <div className={classNames(wrapper, wrapperClassName, styles[size])} data-cy={dataCy}>
      <div className={label_wrapper}>
        {!!props.label?.length && (
          <label className={classNames(element_label, className, { required: props.required })}>{props.label}</label>
        )}
        {props.required && <sup className={error_icon}>٭</sup>}
      </div>

      {children}
      {errors}
      {hint && <p className={hint_message}>{hint}</p>}
    </div>
  );
};
